/* ISCA: ex-VAT / inc-VAT price switch.
   The VAT arithmetic happens in Liquid (snippets/price.liquid). This file only
   decides which of the two rendered figures is the large one, and remembers
   the visitor's choice. */
(function () {
  var KEY = 'isca-vat-mode';
  var root = document.documentElement;

  function readMode() {
    try {
      return localStorage.getItem(KEY) === 'inc' ? 'inc' : 'ex';
    } catch (e) {
      return 'ex';
    }
  }

  function apply(mode) {
    root.classList.toggle('vat-mode-inc', mode === 'inc');
    var buttons = document.querySelectorAll('.isca-vat-switch__btn');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute(
        'aria-pressed',
        buttons[i].getAttribute('data-vat-mode') === mode ? 'true' : 'false'
      );
    }
  }

  function setMode(mode) {
    try {
      localStorage.setItem(KEY, mode);
    } catch (e) {}
    apply(mode);
  }

  // Move the bar to the top of the header group. Editing sections/header.liquid
  // directly would mean rewriting a 48KB file for a 10-line addition.
  function placeBar() {
    var bar = document.querySelector('[data-isca-vat-bar]');
    if (!bar || bar.dataset.iscaPlaced === 'true') return;
    var headerGroup = document.getElementById('header-group');
    if (headerGroup) {
      headerGroup.insertBefore(bar, headerGroup.firstChild);
    }
    bar.dataset.iscaPlaced = 'true';
    bar.removeAttribute('hidden');
  }

  function init() {
    placeBar();
    apply(readMode());
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var btn = target.closest('.isca-vat-switch__btn');
    if (!btn) return;
    event.preventDefault();
    setMode(btn.getAttribute('data-vat-mode') === 'inc' ? 'inc' : 'ex');
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
